// 自定义数学渲染器（当前实现的优化版本）

import { MathRenderer, MathRenderOptions } from '../types';

export class CustomMathRenderer implements MathRenderer {
  isSupported(): boolean {
    return true; // 自定义渲染器总是可用
  }

  render(latex: string, options?: MathRenderOptions): string {
    return this.renderMathContent(latex);
  }

  renderToElement(latex: string, element: HTMLElement, options?: MathRenderOptions): void {
    element.innerHTML = this.render(latex, options);
  }

  private renderMathContent(text: string): string {
    let processedText = text;

    // 首先处理几何符号（在处理$符号之前）
    processedText = processedText.replace(/\\odot\s*([A-Z])/g, '⊙$1');
    processedText = processedText.replace(/\\triangle\s*([A-Z]+)/g, '△$1');
    processedText = processedText.replace(/\\widehat\{([^}]+)\}/g, '$1̂');
    processedText = processedText.replace(/\\angle\s*([A-Z]+)/g, '∠$1');

    // 处理单独的几何符号
    processedText = processedText.replace(/\\odot(?!\s*[A-Z])/g, '⊙');
    processedText = processedText.replace(/\\triangle(?!\s*[A-Z])/g, '△');
    processedText = processedText.replace(/\\angle(?!\s*[A-Z])/g, '∠');

    // 处理角度符号
    processedText = processedText.replace(/\$\\angle\s+([A-Z]+)\s*=\s*(\d+)\^\\circ\$/g, '∠$1 = $2°');
    processedText = processedText.replace(/(\d+)\^\\circ/g, '$1°');

    // 处理分数 - 改进版本
    processedText = processedText.replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, 
      '<span class="math-fraction"><span class="math-numerator">$1</span><span class="math-denominator">$2</span></span>');

    // 处理求和符号
    processedText = processedText.replace(/\\sum_\{([^}]+)\}\^\{([^}]+)\}/g, 
      '<span class="math-sum">∑<sub>$1</sub><sup>$2</sup></span>');
    processedText = processedText.replace(/\\sum/g, '∑');

    // 处理积分
    processedText = processedText.replace(/\\int/g, '∫');

    // 处理上标和下标
    processedText = processedText.replace(/\^(\{[^}]+\}|\w)/g, (match, exp) => {
      const cleanExp = exp.replace(/[{}]/g, '');
      return `<sup>${cleanExp}</sup>`;
    });

    processedText = processedText.replace(/_(\{[^}]+\}|\w)/g, (match, sub) => {
      const cleanSub = sub.replace(/[{}]/g, '');
      return `<sub>${cleanSub}</sub>`;
    });

    // 处理placeholder（MathLive语法）
    processedText = processedText.replace(/\\placeholder\{([^}]+)\}/g, 
      '<span class="math-placeholder">$1</span>');

    // 处理根号
    processedText = processedText.replace(/\\sqrt\{([^}]+)\}/g, 
      '<span class="math-sqrt">√<span class="math-sqrt-content">$1</span></span>');

    // 处理数学符号
    const symbolMap: { [key: string]: string } = {
      '\\cdot': '·',
      '\\times': '×',
      '\\div': '÷',
      '\\pm': '±',
      '\\mp': '∓',
      '\\leq': '≤',
      '\\geq': '≥',
      '\\neq': '≠',
      '\\approx': '≈',
      '\\infty': '∞',
      '\\pi': 'π',
      '\\alpha': 'α',
      '\\beta': 'β',
      '\\gamma': 'γ',
      '\\delta': 'δ',
      '\\Delta': 'Δ',
      '\\theta': 'θ',
      '\\lambda': 'λ',
      '\\mu': 'μ',
      '\\sigma': 'σ',
      '\\phi': 'φ',
      '\\omega': 'ω',
      '\\parallel': '∥',
      '\\perp': '⊥',
      '\\cong': '≅',
      '\\sim': '∼',
      '\\rightarrow': '→',
      '\\leftarrow': '←',
      '\\leftrightarrow': '↔',
      '\\Rightarrow': '⇒',
      '\\Leftarrow': '⇐',
      '\\Leftrightarrow': '⇔',
      '\\in': '∈',
      '\\notin': '∉',
      '\\subset': '⊂',
      '\\supset': '⊃',
      '\\cup': '∪',
      '\\cap': '∩',
      '\\emptyset': '∅',
      '\\exists': '∃',
      '\\forall': '∀',
      '\\partial': '∂',
      '\\nabla': '∇'
    };

    // 应用符号替换
    Object.entries(symbolMap).forEach(([latex, symbol]) => {
      processedText = processedText.replace(new RegExp(latex.replace(/\\/g, '\\\\'), 'g'), symbol);
    });

    // 清理剩余的$符号
    processedText = processedText.replace(/\$/g, '');

    return processedText;
  }
}